import firebase from 'firebase/app';
import 'firebase/functions';

export function httpsCallable (name, options) {
    const app = firebase.app().functions('southamerica-east1');
    // app.useEmulator('localhost', 5001);
    return app.httpsCallable(name, options);
}
